var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fab-transition',[_c('v-btn',{key:"mdi-arrow-collapse-left",staticClass:"v-btn--example",attrs:{"color":"success","fab":"","dark":"","small":"","right":""},on:{"click":_vm.painelAbreFecha}},[_c('v-icon',[_vm._v(_vm._s(_vm.painelIcone))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }